import React from 'react';
interface Traveller {
  name: string;
  dateOfBirth: string;
  passportNo: string;
  expiry: string;
  nationality: string;
  mealNotes?: string;
  visa?: string;
}
interface RoomGroup {
  roomNumber?: string;
  roomType?: string;
  travellers: Traveller[];
}
interface PaxStatementTravellersProps {
  rooms: RoomGroup[];
}
export function PaxStatementTravellers({
  rooms
}: PaxStatementTravellersProps) {
  const hasRoomNumbers = rooms.some(room => room.roomNumber);
  return <div className="mb-6" data-id="element-857">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-858">
        Travellers
      </h3>

      {hasRoomNumbers ?
    // Show grouped by room when room numbers exist
    rooms.map((room, roomIndex) => <div key={roomIndex} className="mb-5" data-id="element-859">
            {/* Room Label */}
            <div className="bg-neutral-100 border border-neutral-200 rounded-t-lg px-4 py-2" data-id="element-860">
              <p className="text-xs font-bold text-neutral-900" data-id="element-861">
                {room.roomNumber} ({room.roomType})
              </p>
            </div>

            {/* Travellers Table */}
            <div className="border border-t-0 border-neutral-200 rounded-b-lg overflow-hidden" data-id="element-862">
              <table className="w-full text-xs" data-id="element-863">
                <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-864">
                  <tr data-id="element-865">
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-866">
                      Traveller Name
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-867">
                      Date of Birth
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-868">
                      Passport No.
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-869">
                      Expiry
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-870">
                      Nationality
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-871">
                      Meal / Notes
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-872">
                      Visa
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-873">
                  {room.travellers.map((traveller, tIndex) => <tr key={tIndex} className="border-b border-neutral-200 last:border-b-0" data-id="element-874">
                      <td className="px-3 py-2.5 font-semibold text-neutral-900" data-id="element-875">
                        {traveller.name}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-876">
                        {traveller.dateOfBirth}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-877">
                        {traveller.passportNo}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-878">
                        {traveller.expiry}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-879">
                        {traveller.nationality}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-700" data-id="element-880">
                        {traveller.mealNotes || '—'}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-881">
                        {traveller.visa || '—'}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>) :
    // Show single table without room grouping when no room numbers
    <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-882">
          <table className="w-full text-xs" data-id="element-883">
            <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-884">
              <tr data-id="element-885">
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-886">
                  Traveller Name
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-887">
                  Date of Birth
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-888">
                  Passport No.
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-889">
                  Expiry
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-890">
                  Nationality
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-891">
                  Meal / Notes
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-892">
                  Visa
                </th>
              </tr>
            </thead>
            <tbody data-id="element-893">
              {rooms.flatMap(room => room.travellers).map((traveller, index) => <tr key={index} className="border-b border-neutral-200 last:border-b-0" data-id="element-894">
                    <td className="px-3 py-2.5 font-semibold text-neutral-900" data-id="element-895">
                      {traveller.name}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-896">
                      {traveller.dateOfBirth}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-897">
                      {traveller.passportNo}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-898">
                      {traveller.expiry}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-899">
                      {traveller.nationality}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-700" data-id="element-900">
                      {traveller.mealNotes || '—'}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-901">
                      {traveller.visa || '—'}
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
}